
    var thecurrenturl = window.location.pathname;
    if(Cookies.get('seenpopup')!= 'seenit' && thecurrenturl != '/account/login' && thecurrenturl != '/account/register'){
      jQuery(document).ready(function(){
       jQuery(window).on('scroll', function(){
      jQuery('#registration-call-to-action-wrapper').show();
     	jQuery('#registration-call-to-action-wrapper').addClass('show');
        Cookies.set('seenpopup','seenit');
      		jQuery('#registration-call-to-action-close p').on('click',
        	 function(){
      				console.log('clicked');
      				jQuery('#registration-call-to-action-wrapper').removeClass('show');
              jQuery('#registration-call-to-action-wrapper').remove();
       				 
      		});
      });
      });
        
    }
